import { forwardRef } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { BaseInputProps } from "./BaseInput.types";

const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>(
  (
    {
      className,
      autoComplete,
      highlightBorder,
      isError,
      errorMessage,
      type = "text",
      ...props
    },
    ref,
  ) => {
    return (
      <input
        type={type}
        aria-invalid={isError}
        aria-describedby={props["aria-describedby"] || errorMessage}
        autoComplete={autoComplete}
        ref={ref}
        className={cn(
          "h-12 min-h-12 w-full rounded-lg border border-border bg-white px-4 py-2.5 text-sm text-neutral-900 outline-none duration-150 placeholder:font-medium placeholder:text-textInfo hover:shadow-sm focus:outline-0 disabled:bg-neutral-100 disabled:text-neutral-400 aria-invalid:border-error",
          {
            "hover:border-inputFocusBorder focus:border-inputFocusBorder focus:ring-0":
              !isError,
          },
          {
            "focus:ring-0 focus:ring-error hover:border-error aria-invalid:focus:border-error":
              isError,
          },
          {
            "border-error": highlightBorder,
          },
          className,
        )}
        {...props}
      />
    );
  },
);

BaseInput.displayName = "BaseInput";

export default BaseInput;
